import React from 'react';
import Icon from '@mdi/react';
import { mdiHelpCircleOutline } from '@mdi/js';
import { Label as BulmaLabel } from 'react-bulma-components/lib/components/form';
import Tooltip from 'components/UIComponents/Tooltip';

import './style.scss';

export const Label = ({
  children,
  icon,
  isEmpty = false,
  required = false,
  hint,
  TooltipProps = {},
  HintIconProps = {},
  ...props
}) => {
  const labelEl = !isEmpty ? (
    <BulmaLabel className={required ? 'is-required' : ''} {...props}>
      <span className="label__text">{children}</span>{' '}
      <span className="label__extra">{icon}</span>
    </BulmaLabel>
  ) : (
    <div className="label label__empty"></div>
  );

  if (hint) {
    return (
      <div className="labelWithTooltip">
        {labelEl}
        <Tooltip
          html={
            <div>
              <p>{hint}</p>
            </div>
          }
          {...TooltipProps}
        >
          <Icon path={mdiHelpCircleOutline} size={1} {...HintIconProps} />
        </Tooltip>
      </div>
    );
  }

  return labelEl;
};

export default Label;
